<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>出厂编号：</label>
                        <el-input v-model="search_Obj.f_factory_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>品牌：</label>
                        <el-input v-model="search_Obj.f_brand" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>设备型号：</label>
                        <el-input v-model="search_Obj.f_device_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>状态：</label>
                        <el-select v-model="search_Obj.f_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('device_state1')" :key="'device_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="factory_code" label="出厂编号" sortable="custom"></el-table-column>
                        <el-table-column prop="brand" label="品牌" sortable="custom"></el-table-column>
                        <el-table-column prop="device_code" label="设备型号" sortable="custom"></el-table-column>
                        <el-table-column prop="state" label="状态" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.state, "device_state1") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="check_date" label="检测日期" sortable="custom">
                            <template slot-scope="scope">
                                <span v-if="scope.row.alert==0">{{ scope.row.check_date }}</span>
                                <span v-else style="color: red;">{{ scope.row.check_date }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    :device_type="device_type"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看流量计"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <Borrow
                    width="600px"
                    :id="model_id"
                    title="设备借调"
                    :isshow="borrow_show"
                    @on-close="closeBorrowDialog">
                </Borrow>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import Borrow from "./borrow.vue"
import listutil from "@/libs/listutil"

export default {
    name: 'flowMeterList1',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns, Borrow},
    data() {
        return {
            m_name: '流量计',
            menu_id: 3310,
            list_url: "/api/admin/flowmeter/list",
            search_Obj: {
                f_device_type: '1',
                f_factory_code: '',
                f_brand: '',
                f_device_code: '',
                f_state: '',
            },
            del_Obj:{
                url:'/api/admin/flowmeter/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['device_state1'],
            device_type: 1,
            borrow_show: false,
        };
    },
    methods: {
        borrow(index, row){
            this.model_id = row.id
            this.borrow_show = true
        },
        closeBorrowDialog(){
            this.borrow_show = false
            this.getListData()
        }
    }
};
</script>